/// <amd-module name="VSSUI/Components/Observer/ReadyableArrayObserver" />
import * as React from "react";
import { Observer } from "./Observer";
import { IReadyableArrayObserverProps } from "./ReadyableArrayObserver.Props";

export class ReadyableArrayObserver<T> extends React.Component<IReadyableArrayObserverProps<T>> {
    private loaded = false;

    public render() {
        const { dataComponent, loadingComponent, zeroDataComponent } = this.props;
        return (
            <Observer data={this.props.data} onUpdate={this.handleLoaded} ready={this.props.data.ready}>
                {(props: { data: T[]; ready: boolean }) => {
                    if (!props.ready) {
                        return loadingComponent ? loadingComponent() : null;
                    }
                    if (props.data.length) {
                        return dataComponent(props.data);
                    }
                    return zeroDataComponent ? zeroDataComponent() : null;
                }}
            </Observer>
        );
    }

    public componentDidUpdate(prevProps: IReadyableArrayObserverProps<T>) {
        if (prevProps.data !== this.props.data) {
            this.loaded = false;
            this.handleLoaded();
        }
    }

    public componentDidMount() {
        this.handleLoaded();
    }

    private handleLoaded = () => {
        if (this.props.data.ready.value && !this.loaded) {
            this.props.onReady && this.props.onReady();
            this.loaded = true;
        }
    };
}
